import roadBlock from './images/roadblock.svg';

const RoadBlockIcon = () => <img src={roadBlock} alt="Graphic of a bird in front of a road block" />;

export default RoadBlockIcon;
